// extracted by mini-css-extract-plugin
export default {"mainText":"ogbBvzI0wqDRpaF26FLt","alertText":"KnhmAk9EFTifSFRgqhUj","form":"D7ybB92OO04rFSIBCt4o","error":"qUD38_TleIbg6hYmZJfV","errorMessage":"FDVnoyswDRW7bDwBPbDw"};